var exports = {
  "k": "xdde3148b--8cdab9--container",
  "w": "xdde3148b--8cdab9--header",
};

module.exports = exports;
